// extracted by css-extract-rspack-plugin
export default {"cls1":"MarketingPageLayout-cls1_ta1","cls2":"MarketingPageLayout-cls2_GJz MarketingPageLayout-cls1_ta1"};